import { render, staticRenderFns } from "./CustomsInfo.vue?vue&type=template&id=0c582d6e&scoped=true&"
import script from "./CustomsInfo.vue?vue&type=script&lang=js&"
export * from "./CustomsInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomsInfo.vue?vue&type=style&index=0&id=0c582d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c582d6e",
  null
  
)

export default component.exports